import { render, staticRenderFns } from "./SettingMenu.vue?vue&type=template&id=f31c2a8a&scoped=true"
import script from "./SettingMenu.vue?vue&type=script&lang=js"
export * from "./SettingMenu.vue?vue&type=script&lang=js"
import style0 from "./SettingMenu.vue?vue&type=style&index=0&id=f31c2a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31c2a8a",
  null
  
)

export default component.exports